import { create } from "apisauce";
import { store } from "../store/config-store";
import { forceLogout, resetStore, loginSuccess } from "../store/actions/auth.actions";
import { dispatch } from "d3";

const auth = create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // headers: {
  //   "Access-Control-Allow-Origin": "*",
  // },
});

const api = create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: localStorage.getItem("access_token"),
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-cache",
    // Pragma: "no-cache",
    // Expires: "0",
  },
});

api.axiosInstance.interceptors.response.use(
  (response) => {
    // console.log("-----interceptor-----", response);
    return response;
  },
  (error) => {
    //console.log(error.response);
    if (error.response.status === 401) {

      // Added By Deep K On 17-01-2022 for generate a aceess token it it has expired Start. 
      const username = localStorage.getItem('uname');
      // const password = process.env.REACT_APP_CRM_PWD;
      const password = btoa(username).slice(btoa(username).length-10,btoa(username).length);
      const payload = {
            username,
            password,
            grant_type: process.env.REACT_APP_GRANT_TYPE,
            client_id: process.env.REACT_APP_CLIENT_ID,
            client_secret: process.env.REACT_APP_CLIENT_SECRET,
          };

      const generteAT = async (payload) =>{
        var qs = require("qs");
        auth.setHeader("Content-Type", "application/x-www-form-urlencoded");
        const res = await auth.post("/access_token",  qs.stringify(payload));
        if (res.ok) {
          api.setHeader("Authorization", res.data.access_token);
          store.dispatch(loginSuccess(res.data));
          return true;
        }else if(res.status === 500){
          store.dispatch(resetStore());
          store.dispatch(forceLogout());
        }else
          return false;    
      }

      if(username && generteAT(payload)){
        return;
      }
      // Added By Deep K On 17-01-2022 for generate a aceess token it it has expired End.

      store.dispatch(resetStore());
      store.dispatch(forceLogout());
      return;
    }
    return error;
  },
);

// const refreshToken = async () => {
//     const token = await api.
// }
export { api, auth };
